export const SAVED_ACCOUNTS_MODAL_PT_BR = {
	holderName: "Titular",
	agency: "Agência",
	accountNumber: "Conta",
	pixKey: "Chave PIX",
	addAccount: "Adicionar conta",
	title: "Contas salvas",
	search: "Buscar conta",
	return: "Voltar",
	default: "Padrão",
	edit: "Editar",
	delete: "Excluir",
};

export type SavedAccountsModalTranslations = typeof SAVED_ACCOUNTS_MODAL_PT_BR;
